<template>
    <div class="on-site">
        <HeaderWebApp />
        <MainButtons />
    </div>
</template>

<script>
import Vue from 'vue'
import ComboSelect from '@/components/Widget/ComboSelect/ComboSelect.vue'
import HeaderWebApp from '@/components/WebApp/HeaderWebApp/HeaderWebApp.vue'
import MainButtons from '@/components/WebApp/MainButtons/MainButtons.vue'

export default Vue.extend({
    name: "OnSite",
    components: {
        HeaderWebApp,
        MainButtons
    },
    data() {
        return {
        }
    },
    components: {
        ComboSelect,
        HeaderWebApp,
        MainButtons
    },
    methods: {
    },
    computed: {
        isLoggedIn : function() {
            return this.$store.getters.isLoggedIn
        },
        room: function() {
            return this.$store.getters.room
        },
        event() { return this.$store.getters.event },
    },
    created () {
    },
    beforeCreate () {
        this.$store.commit(
            'set_room', 
            { value: "general",text: "Salón General", room:"presencial-general"}
        )
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/app';
.on-site {
    min-height: 80vh !important;
}

</style>